import React from 'react';
import { certificateDownloadUrl } from '../../services/certificateApi';

const statusLabel = {
  pendiente: 'Pendiente',
  procesando: 'Procesando',
  exitoso: 'Publicada',
  fallido: 'Fallida',
};

export const CertificateBatchProgress = ({
  batch,
  running = false,
  error = '',
  onResume,
  onRetry,
  onClear,
}) => {
  if (!batch && !running && !error) return null;

  const total = Number(batch?.total) || 0;
  const successful = Number(batch?.exitosos) || 0;
  const failed = Number(batch?.fallidos) || 0;
  const pending = Number(batch?.pendientes) || 0;
  const completed = Math.min(total, successful + failed);
  const students = Array.isArray(batch?.alumnos) ? batch.alumnos : [];

  return (
    <section
      className="certificate-wizard-card certificate-batch-progress"
      aria-labelledby="certificate-batch-progress-title"
    >
      <div className="certificate-wizard-card-heading">
        <span aria-hidden="true">4</span>
        <div>
          <h2 id="certificate-batch-progress-title">Publicación del lote</h2>
          <p>El avance se conserva para continuar después de una interrupción.</p>
        </div>
      </div>

      {batch && (
        <>
          <div className="certificate-batch-summary">
            <strong>
              {successful} {successful === 1 ? 'exitosa' : 'exitosas'}
            </strong>
            <strong>
              {failed} {failed === 1 ? 'fallida' : 'fallidas'}
            </strong>
            <span>
              {pending} {pending === 1 ? 'pendiente' : 'pendientes'}
            </span>
          </div>
          <progress
            aria-label="Progreso del lote"
            max={Math.max(total, 1)}
            value={completed}
          />
          <p className="certificate-batch-state" role="status">
            {running
              ? 'Procesando constancias...'
              : 'Estado del lote: ' + (batch.estado || 'procesando')}
          </p>
        </>
      )}

      {!batch && running && (
        <p className="certificate-batch-state" role="status">
          Creando el lote...
        </p>
      )}

      {error && (
        <p className="certificate-wizard-status" role="alert">
          {error}
        </p>
      )}

      {students.length > 0 && (
        <ul className="certificate-batch-students">
          {students.map((student) => (
            <li key={student.id_lote_alumno || student.id_alumno}>
              <span>{student.nombre_alumno}</span>
              <div className="certificate-batch-student-actions">
                <strong>{statusLabel[student.estado] || student.estado}</strong>
                {student.estado === 'exitoso' && student.id_emision && (
                  <a
                    href={certificateDownloadUrl(
                      `/api/certificados/emisiones/${student.id_emision}/descargar`,
                    )}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Descargar PDF con QR
                  </a>
                )}
              </div>
              {student.estado === 'fallido' && student.mensaje_error && (
                <small>{student.mensaje_error}</small>
              )}
            </li>
          ))}
        </ul>
      )}

      <div className="certificate-wizard-actions certificate-batch-actions">
        {(pending > 0 || batch?.estado === 'procesando') && !running && (
          <button type="button" onClick={onResume}>
            Reanudar lote
          </button>
        )}
        {failed > 0 && !running && (
          <button type="button" onClick={onRetry}>
            Reintentar fallidas
          </button>
        )}
        {batch && !running && (
          <button type="button" className="secondary" onClick={onClear}>
            Crear otro lote
          </button>
        )}
      </div>
    </section>
  );
};
